import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const deleteComment = createAsyncThunk(
  "initiatives/deleteComment",
  async (commentId, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}api/initiatives/comments/${commentId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      );
      if (!response.data?.success) {
        return rejectWithValue(response.data?.message || "Failed to delete comment");
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete comment");
    }
  }
);
